module.exports = __webpack_public_path__ + "img/lourenco.65acedda.jpg";